import styled from 'styled-components'

export const CursorWrapper = styled.div`
    width: 10px;
    height: 18px;
    background: #636e72;
`
